import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { getFormattedPromotion } from '@front/customer/src/utils/cleaning';
import { StandardPrices } from '@front/customer/src/types/prices';

import { translate } from '@front/i18n';

import Separator from '@front/web-ui/src/components/separator/separator';

import ServiceFeeIncludedText from '../../service-fee-included-text';
import Reduction from '../common/reduction';
import { calculationLineStyle } from '../../common';

const t = translate('basket');

const PromotionLine = styled(Reduction)`
  ${calculationLineStyle}
`;

type MultiplePricesWithTaxProps = {
  hasDuration: boolean;
  prices?: StandardPrices;
};

const MultiplePricesWithTax = ({ hasDuration, prices, children }: PropsWithChildren<MultiplePricesWithTaxProps>) => {
  const hasPromo = !!prices?.promotion;

  return (
    <>
      {hasPromo && (
        <>
          <Separator />
          <PromotionLine title={t('.promo_code')} reduction={getFormattedPromotion(hasDuration, prices?.promotion)} />
        </>
      )}
      {children}
      <ServiceFeeIncludedText />
    </>
  );
};

export default MultiplePricesWithTax;
